import { StyledModal } from './style'
import { Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const ApproveModal = ({ title, text, onClick, onCancel, visible, confirmLoading = false }) => {
    return (
        <StyledModal
            title={
                <span>
                    <span className="icon-wrapper">
                        <ExclamationCircleOutlined />
                    </span>
                    {title || 'Подтверждение'}
                </span>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={confirmLoading}>
                    Отмена
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    danger
                    onClick={onClick}
                    loading={confirmLoading}
                >
                    Подтвердить
                </Button>,
            ]}
            width={460}
            centered
            mask={{ closable: false }}
            destroyOnHidden={true}
        >
            <div style={{ padding: '8px 0' }}>{text}</div>
        </StyledModal>
    )
}

export default ApproveModal